import Shimmer from "@/components/base/Shimmer";

export default function ChatListShimmer() {
  const items = Array.from({ length: 9 }, (_, i) => i);

  return (
    <div className="flex flex-col">
      {items.map((i) => (
        <div
          key={i}
          className="flex items-center gap-3 px-3 py-2.5 border-b border-background-100/60"
        >
          {/* Avatar circle */}
          <Shimmer className="w-12 h-12 rounded-full flex-shrink-0" />

          {/* Text lines */}
          <div className="flex-1 min-w-0 flex flex-col gap-1.5">
            {/* Name line - varies width */}
            <Shimmer
              className="h-3 rounded-full"
              style={{ width: `${55 + (i * 7) % 40}%` }}
            />
            {/* Message preview line */}
            <Shimmer
              className="h-2.5 rounded-full"
              style={{ width: `${40 + (i * 13) % 50}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}